import React from "react";
import { useLocation } from "react-router-dom";
import { useUserSession } from "../../session/useUserSession";
import "./SessionPopup.css";

const SessionPopup = () => {
  const { sessionExpired, maxSessionExpired, handleLogout } = useUserSession();
  const location = useLocation();

  // Define excluded routes where the popup should not appear
  const excludedRoutes = [
    "/login",
    "/",
    "/#/",
    "/forgot-password",
    "/register",
    "/reset-password",
  ];

  // Check if the current route is excluded
  const isExcludedRoute = excludedRoutes.includes(location.pathname);

  // Do not render the popup on excluded routes
  if ((!sessionExpired && !maxSessionExpired) || isExcludedRoute) {
    return null;
  }

  const message = sessionExpired
    ? "Your session has expired due to inactivity. Please log in again."
    : "Your session has expired because it has reached the maximum allowed duration. Please log in again.";

  return (
    <div className="session-expiry-popup">
      <div className="popup-content">
        <h3>Session Expired</h3>
        <p>{message}</p>
        <button onClick={handleLogout}>OK</button>
      </div>
    </div>
  );
};

export default SessionPopup;
